import React, { memo } from "react";

//Componentes de Material UI
import {
    Drawer,
    Box,
    Typography,
    Divider,
    IconButton,
    useTheme,
    useMediaQuery,
} from "@mui/material";

//Estilos de Material UI
import { createStyles, styled } from "@mui/material/styles";

//Iconos de Material UI
import { ChevronLeft as ChevronLeftIcon } from "@mui/icons-material/";

//Imagenes
import LogoImg from "../../../../static/images/logo.png";

//Componentes
import GetListAdmin from "./getListAdmin";
import GetListUser from "./getListUser"

const menuStyles = createStyles((theme) => ({
    paper: {
        width: "275.84px !important",
        overflowX: "hidden",
        backgroundImage: "none",
    },
    bntCloseMenu: {
        marginBottom: "11.6px",
        marginTop: "11.6px",
        display: "flex",
        justifyContent: "flex-end",
        [theme.breakpoints.down("sm")]: {
            marginBottom: "7.5px",
            marginTop: "7.5px",
        },
    },
    box: {
        height: "inherit",
        width: "inherit",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        background: "black"
    },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
    minHeight:50,
    background: "black",
    color: "white"
}));

const Menu = ({ open, toggleDrawer, drawerWidth }) => {
    //===============================================================================================================================================
    //========================================== Context ============================================================================================
    //===============================================================================================================================================

    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const theme = useTheme();
    const movil = useMediaQuery(theme.breakpoints.down("sm"));

    //===============================================================================================================================================
    //========================================== Funciones ==========================================================================================
    //===============================================================================================================================================
    const classes = menuStyles(theme);

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    return (
        <Drawer
            sx={{
                width: open ? drawerWidth : 0,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    border: "none",
                    boxSizing: 'border-box',
                },
            }}
            variant={movil ? "temporary" : "persistent"}
            anchor="left"
            open={open}
        >
            <DrawerHeader sx={{ minHeight: "55px" }}>
                <IconButton onClick={toggleDrawer} >
                    {theme.direction === 'ltr' ? <ChevronLeftIcon sx={{ color: "white" }} /> : null}
                </IconButton>
            </DrawerHeader>

            <Divider />

            <Box
                sx={classes.box}
            >
                <Box sx={{ flexGrow: 1, minWidth: "inherit" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src={LogoImg}
                            alt="Icono choucair"
                            style={{
                                width: "150px",
                                height: "45px",
                                marginTop: "20px",
                            }}
                        />
                    </Box>

                    <Box>
                        <GetListUser toggleDrawer={toggleDrawer} movil={movil} />
                        <GetListAdmin toggleDrawer={toggleDrawer} movil={movil} />
                    </Box>
                </Box>
                <Box>
                    <Typography variant="caption">
                        {process.env.REACT_APP_VERSION}
                    </Typography>
                </Box>
            </Box>
        </Drawer>
    );
};

export default memo(Menu);
